/* Prio+ Cart-Upsell
 * Toggle im Warenkorb fügt ein verstecktes Produkt als Line-Item hinzu / entfernt es.
 * Zustand kommt SERVER-SEITIG aus dem gerenderten Toggle (data-prio-in-cart / checked),
 * nicht aus JS — überlebt jeden Drawer-Re-Render.
 * Re-Render: Drawer via Theme-Event 'cart:refresh' (cart-drawer holt sich selbst frisches
 * Section-HTML, theme.js:4374), Cart-Seite via Reload.
 * Pattern angelehnt an assets/koordinaten-apparel.js (loadAufschlagVariantId, /cart/*-Calls).
 */
(function () {
  'use strict';

  var variantCache = {};
  var busy = false;
  var removingStranded = false;

  function loadVariantId(handle) {
    if (Object.prototype.hasOwnProperty.call(variantCache, handle)) {
      return Promise.resolve(variantCache[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var id = (data && data.variants && data.variants[0]) ? data.variants[0].id : null;
        variantCache[handle] = id;
        return id;
      })
      .catch(function () { variantCache[handle] = null; return null; });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function rerender(context) {
    if (context === 'cart') {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }

  /* ---------- Toggle: delegierter Listener (überlebt Drawer-Re-Render) ---------- */
  document.addEventListener('change', function (e) {
    var toggle = e.target && e.target.closest ? e.target.closest('[data-prio-plus-toggle]') : null;
    if (!toggle) return;

    if (busy) { toggle.checked = !toggle.checked; return; }

    var handle = toggle.getAttribute('data-prio-handle');
    var context = toggle.getAttribute('data-context') || 'drawer';
    var inCart = toggle.getAttribute('data-prio-in-cart') === 'true';
    var lineKey = toggle.getAttribute('data-prio-line-key');
    var wantOn = toggle.checked;

    /* Dup-Guard: Zielzustand entspricht schon dem Cart -> nichts tun. */
    if (wantOn === inCart) return;

    busy = true;
    /* busy IMMER zuruecksetzen, sonst blockt jeder Folge-Klick (Toggle liesse sich nicht ausschalten). */
    var done = function () { busy = false; rerender(context); };
    var fail = function () { busy = false; toggle.checked = inCart; };

    if (wantOn) {
      loadVariantId(handle).then(function (variantId) {
        if (!variantId) { fail(); return; }
        return postJSON('/cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties: { _prio_plus: 'true' } }]
        }).then(function (r) { if (!r.ok) { fail(); return; } done(); });
      }).catch(fail);
    } else {
      if (!lineKey) { busy = false; return; }
      postJSON('/cart/change.js', { id: lineKey, quantity: 0 })
        .then(function (r) { if (!r.ok) { fail(); return; } done(); })
        .catch(fail);
    }
  });

  /* ---------- Gestrandetes Prio+ automatisch entfernen ----------
   * Wenn nur noch Prio+ im Cart liegt (kein echtes Produkt), würde sonst ein bezahlter
   * Aufschlag ohne Produkt zurückbleiben. Prüft den Cart server-seitig (DOM-unabhängig). */
  function removeStrandedPrio() {
    if (removingStranded) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var prioItem = null, realCount = 0;
        cart.items.forEach(function (it) {
          if (it.properties && it.properties._prio_plus === 'true') { prioItem = it; }
          else { realCount += it.quantity; }
        });
        if (prioItem && realCount === 0) {
          removingStranded = true;
          postJSON('/cart/change.js', { id: prioItem.key, quantity: 0 })
            .then(function () {
              removingStranded = false;
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            })
            .catch(function () { removingStranded = false; });
        }
      })
      .catch(function () {});
  }
  document.addEventListener('cart:refresh', removeStrandedPrio);
  document.addEventListener('cart-drawer:refreshed', removeStrandedPrio);

  /* ---------- Info-Tooltip: Tap auf Mobile (Hover laeuft per CSS) ---------- */
  document.addEventListener('click', function (e) {
    var info = e.target && e.target.closest ? e.target.closest('.prio-plus__info') : null;
    document.querySelectorAll('.prio-plus__info--open').forEach(function (el) {
      if (el !== info) el.classList.remove('prio-plus__info--open');
    });
    if (info) { e.preventDefault(); info.classList.toggle('prio-plus__info--open'); }
  });
})();
